import script from "./Ellipsis.vue?vue&type=script&lang=jsx"
export * from "./Ellipsis.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__